(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-shared"]) return;
  try {
    
  if ($('.side-cart').length > 0) {
    showCart = function() {
      $('body').addClass('cart-visible');
      $('.transparent-overlay').fadeIn(200);
    };

    hideCart = function() {
      $('body').removeClass('cart-visible');
      $('.transparent-overlay').fadeOut(200);
    }

    $(document).on('cart.requestStarted', function() {
      showCart();
      $('form[action^="/cart"] [type="submit"]').prop('disabled', true);
    });

    $(document).on('cart.requestComplete', function() {
      $('form[action^="/cart"] [type="submit"]').prop('disabled', false);
    });

    $(document).on('click', '.js-cart-show', function(e) {
      e.preventDefault();
      showCart();
    });

    $(document).on('click', '.js-cart-hide', function(e) {
      e.preventDefault();
      hideCart();
    });
  }

  $(document).on('click', '.item-convert', function(e) {
    e.preventDefault();
    var current_variant = $(this).data().current_variant;
    var quantity = $(this).data().quantity;
    var shipping_interval_frequency = $(this).data().shipping_interval_frequency;
    var shipping_interval_unit_type = $(this).data().shipping_interval_unit_type;
    var subscription_id = $(this).data().subscription_id;
    var subscription_variant = $(this).data().subscription_variant;

    var properties = {
      shipping_interval_frequency: shipping_interval_frequency,
      shipping_interval_unit_type: shipping_interval_unit_type,
      subscription_id: subscription_id
    }

    CartJS.addItem(subscription_variant, quantity, properties, { skipGetCart: true } )
    CartJS.removeItemById(current_variant);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-gate-global"]) return;
  try {
    
  var $emailGate = $('.email-gate-outer');
  var isGated = $emailGate.children().length > 0
  var showGate = $.deparam.querystring().gate;

  if (showGate == 'false' && !(Cookies.get('email_collected') || Cookies.get('email_dismissed'))) {
    // Force the email collection gate to be surpressed for the duration of the session
    Cookies.set('email_dismissed', 1);
  } else if (showGate == 'true') {
    // Reset the email cookie to force the gate to behave as if not email has been entered
    Cookies.remove('email_dismissed');
    Cookies.remove('email_collected')
  }
  if (Cookies.get('email_collected') || Cookies.get('email_dismissed')) {
    $emailGate.remove();
  } else {

    function remove() {
      $emailGate.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
        function(event) {
        $emailGate.remove();
      });
      $emailGate.removeClass('visible');
    }

    $('.email-gate--background', $emailGate).on('touchstart click', function() {
      Cookies.set('email_dismissed', 1);
      remove();
    })

    setTimeout(function() {
      $('.email-gate-outer').show(0, function() { $('.email-gate-outer').addClass('visible') })
    }, (showGate == "true" ? 1000 : 30000));

    emailSubmit($emailGate, function() {
      setTimeout(function() {
        remove();
      }, 1000);
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-gate-product"]) return;
  try {
    
  var $emailGate = $('.email-gate-outer');
  var isGated = $emailGate.children().length > 0
  var showGate = $.deparam.querystring().gate;
  if (showGate == 'false' && !Cookies.get('email_collected')) {
    // Force the email collection gate to be surpressed for the duration of the session
    Cookies.set('email_collected', true);
  } else if (showGate == 'true') {
    // Reset the email cookie to force the gate to behave as if not email has been entered
    Cookies.remove('email_collected');
  }
  if (Cookies.get('email_collected')) {
    $emailGate.remove();
  } else {

    function remove() {
      $emailGate.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
        function(event) {
        $emailGate.remove();
      });
      $emailGate.removeClass('visible');
    }

    setTimeout(function() {
      $('.email-gate-outer').show(0, function() { $('.email-gate-outer').addClass('visible') })
    }, 1000);

    emailSubmit($emailGate, function() {
      setTimeout(function() {
        remove();
      }, 1000);
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

emailSubmit($('footer'));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  $('.js-show-drawer').click(function(){
    $('#mobile-header').addClass('drawer-visible');
  });

  $('.js-hide-drawer').click(function(){
    $('#mobile-header').removeClass('drawer-visible');
  });

  var lastScrollTop = 0;
  function didScroll(e) {
    var st = $(this).scrollTop();
    var $header = $('#shopify-section-header');
    var headerHeight = $('#shopify-section-header').outerHeight();
    if (st <= 0) {
      $('.site-header', $header).css({ position: 'static', top: -headerHeight });

    } else if (st > lastScrollTop) {
      // downscroll code

      if (st > headerHeight) {
        $('.site-header', $header).css({ position: 'fixed', top: -headerHeight });
      }
    } else {
      // upscroll code
      $('.site-header', $header).css({ top: 0 });
    }

    lastScrollTop = st;
  }

  didScroll();


  throttled = _.throttle(didScroll, 20 );
  if (window.addEventListener) {
    window.addEventListener('scroll', throttled, false);
  } else if (window.attachEvent) {
    window.attachEvent('onscroll', throttled);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-plan-hero"] && !Shopify.designMode) return;
  try {
    
  $(".marquee").marquee();
  $(".marquee").trigger("forward");


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-related"]) return;
  try {
    
  $('.add-to-cart-button#related-products').on('click', function() {
    relatedItems.forEach(function(itemArguments){
      CartJS.addItem.apply(this, itemArguments);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
